const formatPrice = (value, currency = 'BRL') => Number(value).toLocaleString('pt-br', { style: 'currency', currency });

export default formatPrice;
